import React from 'react'
import eCharts from './echartConfig'
import style from './style.css'
import {TextButton, TextButtonTypes} from '../Buttons'

const COLORS = ['rgb(217, 41, 102)',
  'rgb(116, 48, 255)',
  'rgb(0, 136, 255)', 'rgb(48, 217, 98)',
  'rgb(241, 126, 53)',
  'rgb(154, 168, 178)',
  'rgb(112, 122, 130)',
  'rgb(166,31,78)',
  'rgb(115,22,54)',
  'rgb(93,38,204)',
  'rgb(70, 29, 153)',
  'rgb(0, 109, 204)',
  'rgb(0, 82, 153)',
  'rgb(36, 166, 75)',
  'rgb(25,115,52)',
  'rgb(191, 100, 42)',
  'rgb(140, 73, 31z)']

const FONT_FAMILY = 'Brown-Regular, Montserrat, sans-serif'

const TOOLTIP_HIDE_DELAY = 3000

class Chart extends React.PureComponent {
  constructor(props) {
    super(props)
    this.id = props.chartId
    window.chartInstance = null
    this.state = {
      area: false,
      smooth: false,
      scale: false,
      orientation: false,
      stacked: false,
      doughnut: false
    }
    this.mounted = false
  }

  changeArea = () => {
    this.setState({ area: !this.state.area })
  }
  changeSmooth = () => {
    this.setState({ smooth: !this.state.smooth })
  }
  changeScale = () => {
    this.setState({ scale: !this.state.scale })
  }
  changeOrientation = () => {
    this.setState({ orientation: !this.state.orientation })
  }
  changeStacked = () => {
    this.setState({ stacked: !this.state.stacked })
  }
  changeDoughnut = () => {
    this.setState({ doughnut: !this.state.doughnut })
  }

  getBarOptions() {
    const options = {
      xAxis: {
        type: 'category',
        data: this.props.data.xAxis.data,
        name: this.props.data.xAxis !== undefined ? this.props.data.xAxis.name : '',
        nameLocation: 'middle',
        nameGap: 25,
        nameTextStyle: {
          fontWeight: 'bold',
          fontFamily: FONT_FAMILY
        },
        axisLabel: {
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        }
      },
      yAxis: {
        type: 'value',
        name: this.props.data.yAxis !== undefined ? this.props.data.yAxis.name : '',
        nameLocation: 'middle',
        nameRotate: 90,
        nameGap: 45,
        nameTextStyle: {
          fontWeight: 'bold',
          fontFamily: FONT_FAMILY
        },
        axisLabel: {
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      legend: {
        data: this.props.data.series.map(item => item.name),
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      series: this.props.data.series.map((item, i) => {
        return {
          color: item.color ? item.color : COLORS[i % COLORS.length],
          name: item.name,
          data: item.data,
          type: 'bar'
        }
      })
    }
    if (this.state.orientation) {
      options.xAxis = { type: 'value', name: this.props.data.yAxis !== undefined ? this.props.data.yAxis.name : '' }
      options.yAxis = {
        type: 'category',
        data: this.props.data.xAxis.data,
        name: this.props.data.xAxis !== undefined ? this.props.data.xAxis.name : ''
      }
    }
    if (this.state.stacked) {
      options.series = this.props.data.series.map((item, i) => {
        return {
          color: item.color ? item.color : COLORS[i % COLORS.length],
          name: item.name,
          data: item.data,
          type: 'bar',
          stack: '1'
        }
      })
    }
    return options
  }

  getLineOptions() {
    const selected = {}
    for (const item of this.props.data.series) {
      selected[item.name] = !item.disabled
    }
    const options = {
      tooltip: {
        hideDelay: TOOLTIP_HIDE_DELAY,
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      legend: {
        data: this.props.data.series.map(item => item.name),
        selected: selected,
        type: 'scroll',
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      xAxis: {
        type: 'category',
        data: this.props.data.xAxis.data,
        name: this.props.data.xAxis !== undefined ? this.props.data.xAxis.name : '',
        nameLocation: 'middle',
        nameGap: 25,
        nameTextStyle: {
          fontWeight: 'bold',
          fontFamily: FONT_FAMILY
        },
        axisLabel: {
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        }
      },
      yAxis: {
        type: 'value',
        name: this.props.data.yAxis !== undefined ? this.props.data.yAxis.name : '',
        nameLocation: 'middle',
        nameRotate: 90,
        nameGap: 45,
        nameTextStyle: {
          fontWeight: 'bold',
          fontFamily: FONT_FAMILY
        },
        axisLabel: {
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        }
      },
      series: this.props.data.series.map((seriesItem, i) => {
        return {
          type: 'line',
          name: seriesItem.name,
          showAllSymbol: true,
          color: seriesItem.color ? seriesItem.color : COLORS[i % COLORS.length],
          lineStyle: {
            width: 4
          },
          data: seriesItem.data.map(value => {
            if (typeof value !== 'object') {
              return { value }
            } else if (value.tooltip !== undefined && value.tooltip !== null) {
              if (value.tooltip.img !== null && value.tooltip.text === null) {
                return {
                  value: value.value,
                  tooltip: {
                    trigger: 'item',
                    hideDelay: TOOLTIP_HIDE_DELAY,
                    formatter: `<div ${value.tooltip.url ? `onclick="window.open('${value.tooltip.url}','_blank')"` : ''} style="white-space: initial !important; ${value.tooltip.url ? 'cursor:pointer;' : ''} width: 240px; height:240px; position:relative; background-image:url(${value.tooltip.img}); background-position: center center; background-size: cover;"></div>`,
                    textStyle: {
                      fontFamily: FONT_FAMILY
                    }
                  }
                }
              }
              else if ((value.tooltip.img === null || value.tooltip.img === '') && value.tooltip.text !== null) {
                return {
                  value: value.value,
                  tooltip: {
                    hideDelay: TOOLTIP_HIDE_DELAY,
                    trigger: 'item',
                    formatter: `<div ${value.tooltip.url ? `onclick="window.open('${value.tooltip.url}','_blank')"` : ''} style="white-space: initial !important; width: 240px; ${value.tooltip.url ? 'cursor:pointer;' : ''} height:120px; position:relative; overflow:hidden;"><div style="position: absolute; word-break: break-all !important; width: 240px; height: 120px; bottom: 0; margin-right: -17px; overflow-y: scroll; left: 0; background-color: rgba(0,0,0,0.8); padding:5px; text-overflow: ellipsis; line-height: 15px;">${value.tooltip.text}</div></div>`,
                    textStyle: {
                      fontFamily: FONT_FAMILY
                    }
                  }
                }
              } else {
                return {
                  value: value.value,
                  tooltip: {
                    hideDelay: TOOLTIP_HIDE_DELAY,
                    trigger: 'item',
                    formatter: `<div ${value.tooltip.url ? `onclick="window.open('${value.tooltip.url}','_blank')"` : ''} style="white-space: initial !important; width: 240px; ${value.tooltip.url ? 'cursor:pointer;' : ''} height:240px; position:relative; overflow:hidden; background-image:url(${value.tooltip.img}); background-position: center center; background-size: cover;"><div style="position: absolute; word-break: break-all !important; width: 240px; height: 120px; bottom: 0; margin-right: -17px; overflow-y: scroll; left: 0; background-color: rgba(0,0,0,0.8); padding:5px; text-overflow: ellipsis; line-height: 15px;">${value.tooltip.text}</div></div>`,
                    textStyle: {
                      fontFamily: FONT_FAMILY
                    }
                  }
                }
              }
            } else {
              return {
                value: value.value
              }
            }
          })
        }
      })
    }
    if (this.state.area) {
      options.xAxis.boundaryGap = false
      options.series = options.series.map(seriesItem => Object.assign({}, seriesItem, { areaStyle: {} }))
    }
    if (this.state.smooth) {
      options.series = options.series.map(seriesItem => Object.assign({}, seriesItem, { smooth: true }))
    }
    if (this.state.stacked) {
      options.series = options.series.map(seriesItem => Object.assign({}, seriesItem, { stack: 'stack' }))
      options.tooltip.trigger = 'axis'
      options.xAxis.boundaryGap = false
      options.grid = {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      }
    }
    if (this.state.scale) {
      options.tooltip.position = function (pt) {
        return [pt[0], '10%'];
      }
      options.xAxis.boundaryGap = false
      options.dataZoom = [{
        type: 'inside',
        start: 0,
        end: 10
      }, {
        start: 0,
        end: 10,
        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        handleSize: '80%',
        handleStyle: {
          color: '#fff',
          shadowBlur: 3,
          shadowColor: 'rgba(0, 0, 0, 0.6)',
          shadowOffsetX: 2,
          shadowOffsetY: 2
        },
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      }]
      options.series = options.series.map(seriesItem => {
        return {
          type: 'line',
          name: seriesItem.name,
          data: seriesItem.data,
          sampling: 'average',
          symbol: 'none',
          smooth: true,
          areaStyle: {}
        }
      })
    }
    return options
  }

  getPieOptions() {
    const options = {
      /*title: {
          text: this.props.data.title,
          x: 'center'
      },*/
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      legend: {
        orient: 'vertical',
        right: 10,
        top: 20,
        bottom: 20,
        data: this.props.data.series[0].data.map(item => item.name),
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      series: this.props.data.series.map(seriesItem => {
        return {
          name: seriesItem.name,
          type: 'pie',
          radius: '55%',
          center: ['50%', '50%'],
          data: seriesItem.data.map((item, i) => {
            return {
              ...item,
              itemStyle: {
                color: item.color ? item.color : COLORS[i % COLORS.length],
                textStyle: {
                  fontFamily: FONT_FAMILY
                }
              }
            }
          }),
          itemStyle: {
            normal: {

              label: {
                textStyle: {
                  fontFamily: FONT_FAMILY
                }
              }

            },
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              textStyle: {
                fontFamily: FONT_FAMILY
              },
              label: {
                textStyle: {
                  fontFamily: FONT_FAMILY
                }
              }
            },
            textStyle: {
              fontFamily: FONT_FAMILY
            }
          }
        }
      })
    }
    if (this.state.doughnut) {
      options.series[0].radius = ['50%', '70%']
      options.series[0].avoidLabelOverlap = false
      options.series[0].label = {
        normal: {
          show: false,
          position: 'center',
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        },
        emphasis: {
          show: true,
          textStyle: {
            fontSize: '30',
            fontWeight: 'bold',
            fontFamily: FONT_FAMILY

          }
        }
      }
    }
    return options
  }

  getRadarOptions() {
    const options = {
      /*title: {
          text: this.props.title
      },*/
      tooltip: {
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      legend: {
        data: this.props.data.series[0].data.map(item => item.name),
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      radar: {
        shape: 'circle',
        name: {
          textStyle: {
            color: '#fff',
            backgroundColor: '#999',
            borderRadius: 3,
            padding: [3, 5],
            fontFamily: FONT_FAMILY
          }
        },
        indicator: this.props.data.indicator
      },
      series: this.props.data.series.map(seriesItem => {
        return {
          name: seriesItem.name,
          data: seriesItem.data.map((item, i) => {
            return {
              ...item,
              itemStyle: {
                color: item.color ? item.color : COLORS[i % COLORS.length],
                textStyle: {
                  fontFamily: FONT_FAMILY
                }
              }
            }
          }),
          type: 'radar'
        }
      })
    }
    if (this.state.area) {
      options.series[0].areaStyle = { normal: {} }
    }
    return options
  }

  getScatterOptions() {
    return {
      /*title: {
          text: this.props.title
      },*/
      xAxis: {
        type: 'value',
        name: this.props.data.xAxis !== undefined ? this.props.data.xAxis.name : '',
        nameLocation: 'middle',
        nameGap: 25,
        nameTextStyle: {
          fontWeight: 'bold',
          fontFamily: FONT_FAMILY
        },
        axisLabel: {
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        }
      },
      legend: {
        orient: 'vertical',
        right: 10,
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      yAxis: {
        type: 'value',
        name: this.props.data.yAxis !== undefined ? this.props.data.yAxis.name : '',
        nameLocation: 'middle',
        nameRotate: 90,
        nameGap: 45,
        nameTextStyle: {
          fontWeight: 'bold',
          fontFamily: FONT_FAMILY
        },
        axisLabel: {
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        textStyle: {
          fontFamily: FONT_FAMILY
        }
      },
      series: this.props.data.series.map((item, i) => {
        return {
          color: item.color ? item.color : COLORS[i % COLORS.length],
          symbolSize: 20,
          data: item.data,
          type: 'scatter',
          name: item.name,
          textStyle: {
            fontFamily: FONT_FAMILY
          }
        }
      })
    }
  }

  lineToolbox({area, smooth, scale}) {
    return <React.Fragment>
      <TextButton type={area ? TextButtonTypes.secondary : TextButtonTypes.primary} text={'area'} onClick={this.changeArea}/>
      <TextButton type={smooth ? TextButtonTypes.secondary : TextButtonTypes.primary} text={'smooth'} onClick={this.changeSmooth}/>
      <TextButton type={scale ? TextButtonTypes.secondary : TextButtonTypes.primary} text={'scale'} onClick={this.changeScale}/>
    </React.Fragment>
  }

  barToolbox() {
    return null
  }

  pieToolbar() {
    return null
  }

  radarToolbar() {
    return null
  }

  resize = () => {
    window.chartInstance.resize()
  }

  componentDidMount() {
    if (this.props.data) {
      window.chartInstance = eCharts.init(this.chart)
      this.update()
      window.chartInstance.resize()
      window.addEventListener('resize', this.resize)
      this.mounted = true
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      if (!prevProps.data) {
        window.chartInstance = eCharts.init(this.chart)
        window.chartInstance.resize()
        window.addEventListener('resize', this.resize)
        this.mounted = true
      }
    }
    this.update()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  update() {
    if (!window.chartInstance || !this.props.data) {
      return
    }
    let options = {}
    switch (this.props.type) {
      case 'LINE':
        options = this.getLineOptions()
        break
      case 'BAR':
        options = this.getBarOptions()
        break;
      case 'PIE':
        options = this.getPieOptions()
        break
      case 'RADAR':
        options = this.getRadarOptions()
        break
      case 'SCATTER':
        options = this.getScatterOptions()
        break
      default:
    }
    window.chartInstance.setOption(options, true)
  }

  render() {
    const { type } = this.props

    const  toolbox = ((state) => {
      switch (type) {
        case 'LINE':
          return this.lineToolbox(state)
        case 'BAR':
          return this.barToolbox()
        case 'PIE':
          return this.pieToolbar()
        case 'RADAR':
          return this.radarToolbar()
        default:
      }
    })(this.state)

    return <div className={style.chartContainer}>
        <div ref={chart => this.chart = chart}
           className={style.chartView}
           id='chartViewDiv'
           style={type === 'SCATTER' ? { height: '100%' } : {}}>
        </div>
        {toolbox !== null &&
        <div className={style.chartToolbox}>
          {toolbox}
        </div>}
    </div>
  }
}


export default Chart


// WEBPACK FOOTER //
// ./src/components/Chart/index.js